import { Directive, inject } from '@angular/core';
import { AuthNavigationService } from '@domains/auth/auth-navigation.service';
import { getIsClerk } from '@shared/utils';

@Directive({
  selector: '[appReturnToSearch]',
  host: {
    '(click)': 'returnToSearch()',
  },
})
export class ReturnToSearchDirective {
  private readonly _authNavigationService = inject(AuthNavigationService);
  private readonly _isClerk = getIsClerk();

  protected returnToSearch() {
    if (this._isClerk()) {
      this._authNavigationService.navigateToAdminDashboard();
      return;
    }
    this._authNavigationService.goToApplications();
  }
}
